import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, forwardRef } from 'react';
import ErrorBoundary from './ErrorBoundary.js';
export const createSuspenseBoundary = (options) => {
    const { useExpireCache, useBoundaryConfig } = options;
    function CacheConnectedErrorBoundary(props) {
        const expire = useExpireCache();
        return _jsx(ErrorBoundary, { onExpireResource: expire, ...props });
    }
    function SuspenseBoundary(props) {
        const defaultConfig = useBoundaryConfig();
        const { pendingFallback = defaultConfig.pendingFallback, renderError = defaultConfig.renderError, children, onErrorCaught = defaultConfig.onErrorCaught, } = props;
        return (_jsx(CacheConnectedErrorBoundary, { renderError: renderError, onErrorCaught: onErrorCaught, children: _jsx(Suspense, { fallback: pendingFallback, children: children }) }));
    }
    function withBoundary(options = {}) {
        const { pendingFallback: pendingFactory, ...boundaryProps } = options;
        return function withBoundaryIn(ComponentIn) {
            const ComponentOut = forwardRef(function ComponentOut(props, ref) {
                const pendingFallback = typeof pendingFactory === 'function'
                    ? pendingFactory(props)
                    : pendingFactory;
                return (_jsx(SuspenseBoundary, { pendingFallback: pendingFallback, ...boundaryProps, children: _jsx(ComponentIn, { ref: ref, ...props }) }));
            });
            ComponentOut.displayName = `withBoundary(${ComponentIn.displayName || ComponentIn.name || 'Unknown'})`;
            return ComponentOut;
        };
    }
    return {
        Boundary: SuspenseBoundary,
        withBoundary,
    };
};
//# sourceMappingURL=boundary.js.map